import {
    GOOD_PRACTICE_CREATE_FORM_DIALOG_HIDE,
    GOOD_PRACTICE_CREATE_FORM_DIALOG_SHOW,
    GoodPracticeCreateFormActions
} from './good-practice-create-form.actions';

export interface State {
    dialogShow: boolean;
}

const initialState = {
    dialogShow: false,
};

export function tagGoodPracticeCreateReducer(state: State = initialState, action: GoodPracticeCreateFormActions) {
    switch (action.type) {
        case GOOD_PRACTICE_CREATE_FORM_DIALOG_SHOW:
            state = {
                ...state,
                dialogShow: true
            };
            break;
        case GOOD_PRACTICE_CREATE_FORM_DIALOG_HIDE:
            state = {
                ...state,
                dialogShow: false
            };
            break;
        default:
            state = {
                ...state
            };
    }
    return state;
}
